import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OrganizationType } from "types/enum";
import { ENDPOINTS } from "utils/endpoints";
import { trans } from "utils/helpers";
import {
  getWidgetList
} from "./api/api";
import { WidgetBoard } from "./components/Board/WidgetBoard";
import { WidgetCalendar } from "./components/Calendar/WidgetCalendar";
import { WidgetClock } from "./components/Clock/WidgetClock";
import { MyOwnRequests } from "./components/MyOwnRequests/MyOwnRequests";
import { WidgetPositions } from "./components/Positions/WidgetPositions";
import { WidgetQuote } from "./components/Quote/WidgetQuote";
import { WidgetSales } from "./components/SaleWidget/SaleWidget";
import { ShortcutWidget } from "./components/ShortcutWidget/ShortcutWidget";
import { GalleryWidget } from "./GalleryWidget/GalleryWidget";
import "./style.scss";
import { GUID_EMPTY } from "utils/constants";
import { getEnv } from "config/runtimeEnv";

const widgets: { element: React.ReactNode; id: string }[] = [
  { element: <WidgetClock id="DayInfo" />, id: "DayInfo" },
  { element: <WidgetQuote id="DayMessage" />, id: "DayMessage" },
  { element: <WidgetPositions id="cartable" />, id: "cartable" },
  { element: <WidgetCalendar id="WeekEvents" />, id: "WeekEvents" },
  // { element: <WidgetPersonalTask id="PersonalTasks" />, id: "PersonalTasks" },
  { element: <MyOwnRequests id="MyOwnRequests" />, id: "MyOwnRequests" },
];

export const DashboardPage = () => {
  const layoutContext = useContext(LayoutContext);

  const [widgetList, setWidgetList] = useState<any>(null);
  const [Board, setBoard] = useState<any>(false);
  const [gallery, setGallery] = useState<any>(false);
  const [tasks, setTask] = useState<any>([]);
  const [galleryResponse,setGalleryResponse]=useState<any>([])
  const [boardResponse,setBoardResponse]=useState<any>([])
  const [chatNotSeenLength, setChatNotSeenLength] = useState<any>(0);

  async function getWidgetListAsync() {
    try {
      let obj = {};
      const res = await getWidgetList(
        layoutContext?.currentUserPosition?.OrganizationType ==
          OrganizationType.Customers
      );
      let list: any = [];
      let bordFlag = false;
      let galleryFlag = false;
      res.Data.forEach((id) => {
        if (id != "Board" && id!="GalleryBoard") {
          obj[id] = true;
          const item = widgets.find((item) => item.id === id);
          list.push(item);
        }else if(id!="GalleryBoard"){
           setGallery(true);
          obj[id] = true;
          galleryFlag = true;
        }
         else {
          setBoard(true);
          obj[id] = true;
          bordFlag = true;
        }
      });
      if (!bordFlag) {
        setBoard(false);
        obj["Board"] = false;
      }
        if (!galleryFlag) {
        setGallery(false);
        obj["GalleryBoard"] = false;
      }
      setWidgetList(list);
      localStorage.setItem("widgetList", JSON.stringify(obj));

      localStorage.removeItem("widgets");
      return res.Data;
    } catch (error) {}
  }

  useEffect(() => { 
    if (
      localStorage.getItem("widgetList") == null &&
      layoutContext?.currentUserPosition?.OrganizationType != undefined
    ) {
      getWidgetListAsync();
    } else if (
      layoutContext?.currentUserPosition?.OrganizationType != undefined
    ) {
      let list: any = [];
      let localwidgetList: any = localStorage.getItem("widgetList");
      Object.keys(JSON.parse(localwidgetList)).forEach((id) => {
        if (id !== "Board" &&id!='GalleryBoard' &&JSON.parse(localwidgetList)[id]) {
          const item = widgets.find((item) => item.id === id);
          list.push(item);
        }
      });

      const item: any = Object.keys(JSON.parse(localwidgetList)).find(
        (item) => item == "Board"
      ); 

      const itemGallery: any = Object.keys(JSON.parse(localwidgetList)).find(
        (item) => item == "GalleryBoard"
      ); 
      if (JSON.parse(localwidgetList)[item]) {
        setBoard(true);
      } else {
        setBoard(false);
        if (
          layoutContext?.currentUserPosition?.OrganizationType ==
          OrganizationType.Customers
        ) {
          setBoard(true);
        } else {
        }
      }
            if (JSON.parse(localwidgetList)[itemGallery]) {
        setGallery(true);
      } else {
        setGallery(false);
        if (
          layoutContext?.currentUserPosition?.OrganizationType ==
          OrganizationType.Customers
        ) {
          setGallery(true);
        } else {
        }
      }
      setWidgetList(list === null ? widgets : list ? list : []);
    }
  }, [
    layoutContext.widgetFormFlag,
    layoutContext?.currentUserPosition?.OrganizationType,
  ]);

  return (
    <div className="">
      <div className=" p-2 d-none d-lg-block shortcutWidget mb-3 ">
        <div className="row justify-content-between px-5">
          {/* admin */}
          {layoutContext?.currentUserPosition?.OrganizationType !=
            OrganizationType.Customers &&
            layoutContext?.currentUserPosition?.OrganizationType !=
              undefined && (
              <div className="col col-xl-3 ">
                <ShortcutWidget
                  route={"/cartable/current"}
                  color={"text-warning"}
                  type={"cartable"}
                  icon={"bell"}
                  subTilte={
                    <>
                      {layoutContext.notificount > 99
                        ? "99+"
                        : layoutContext.notificount == 0
                        ? 0
                        : layoutContext.notificount}
                      &nbsp; {trans("Msg_NewTaskCount")}
                    </>
                  }
                  title={
                    <>
                      {trans("cartable")} {trans("current")}
                    </>
                  }
                />
              </div>
            )}
          {/* customer */}
          {layoutContext?.currentUserPosition?.OrganizationType ==
            OrganizationType.Customers &&
            layoutContext.currentApplication?.Name == "ClientPortal" && (
              <div className="col col-xl-3 ">
                <ShortcutWidget
                  route={"/my-own-requests"}
                  color={"text-warning"}
                  type={"myRequest"}
                  icon={"bell"}
                  subTilte={
                    <>
                      {tasks > 99 ? "99+" : tasks == 0 ? 0 : tasks}
                      &nbsp; {trans("Msg_PendingTaskCount")}
                    </>
                  }
                  title={trans("myCartable")}
                  url={ENDPOINTS.clientPortal.clientPortal.requestsLength}
                  setData={(e) => setTask(e.Data)}
                />
              </div>
            )}

          {/* public */}
          <div className="col col-xl-3 me-xl-0 me-2 ">
            <ShortcutWidget
              route={"/message"}
              color={"text-info"}
              type={"chat"}
              icon={"message"}
              subTilte={
                <>
                  {chatNotSeenLength > 99
                    ? "99+"
                    : chatNotSeenLength == 0
                    ? 0
                    : chatNotSeenLength}
                  &nbsp; {trans("Msg_UnreadMessageCount")}
                </>
              }
              title={trans("chatmessage")}
              baseUrl={getEnv("REACT_APP_CHAT_SERVICE_URL")}
              url={ENDPOINTS.messageHub.chatNotSeenLength}
              setData={(e) => setChatNotSeenLength(e.Data.Messages)}
            />
          </div>
          {/* customer */}
          {layoutContext?.currentUserPosition?.OrganizationType ==
            OrganizationType.Customers &&
            layoutContext.currentApplication?.Name == "ClientPortal" && (
              <div className="col col-xl-3 me-xl-0 me-2">
                <ShortcutWidget
                  route={""}
                  color={"text-success"}
                  type={""}
                  icon={"file-invoice-dollar"}
                  subTilte={
                    <Link to={"/my-own-invoices"}>
                  {trans("myowninvoices")}
                  </Link>
                  }
                  title={
                    <Link to={"/my-own-orders"}>
                     {trans("myownorders")}
                    </Link>
                  }
                  customStyle={{fontSize:'14px',fontWeight:'400'}}
                />
              </div>
            )}
          {/* admin */}
          {layoutContext?.currentUserPosition?.OrganizationType !=
            OrganizationType.Customers &&
            layoutContext?.currentUserPosition?.OrganizationType !=
              undefined && (
              <div className="col col-xl-3 me-xl-0 me-2">
                <ShortcutWidget
                  route={"/personal-planing/personal-tasks"}
                  color={"text-success"}
                  type={"personalTasks"}
                  icon={"list-check"}
                  subTilte={
                    <>
                      {tasks > 99
                        ? "99+"
                        : tasks == 0
                        ? '0'
                        : tasks}
                      &nbsp; {trans("Msg_IncompleteTaskCount")}
                    </>
                  }
                  title={trans("personaltask")}
                  url={ENDPOINTS.Widget.personalTask}
                  setData={(e) =>setTask(e.Data?.length)}
                />
              </div>
            )}
        </div>
      </div>

      <div className="dashboard">
<div className="row mb-3 justify-content-between">
{gallery &&<GalleryWidget boardResponse={boardResponse} Board={Board} handleGalleryResponse={(e)=>setGalleryResponse(e)}/>}
        {Board && (
          <div className={`col-12 ${(!gallery || galleryResponse?.[0]?.Id==GUID_EMPTY ) && boardResponse?.Data?.[0]?.Id!=GUID_EMPTY?'col-12':boardResponse?.TotalRecords>1 ?layoutContext.sidebarIsOpen?'col-xl-6 col-md-4':'col-md-4 col-lg-6':boardResponse?.Data?.[0]?.Id==GUID_EMPTY?'d-none':'col-md-4'}  dashboard__board`}>
            <WidgetBoard  setBoardResponse={setBoardResponse}  galleryResponse={!!galleryResponse?.length} id="Board" />
          </div>
        )}
</div>
        {widgetList && (
          <div
            className={`dashboard__widgets mx-auto fullscreen ${"justify-content-between"} row mb-2`}
          >
            {widgetList.map((item,index) => (
              <div key={index} className="col-12 px-1 col-md-4 col-lg-3">
                {item != undefined && item.id != "PersonalTasks" && (
                  <div key={item.id}>{item.element}</div>
                )}
              </div>
            ))}
            {layoutContext?.currentUserPosition?.OrganizationType ==
              OrganizationType.Customers && <WidgetSales id={"WidgetSales"} />}
          </div>
        )}
      </div>
    </div>
  );
};
